import { ui } from "../../../shared/styles/uiSystem"

export const sectionCardStyle = {
  ...ui.card,
  padding: 18,
  borderRadius: 20,
  background: "linear-gradient(180deg, #ffffff 0%, #fcfdff 100%)",
}

export const inputStyle = {
  ...ui.input,
  height: 46,
  minHeight: 46,
  padding: "0 14px",
  fontWeight: 600,
  lineHeight: 1.4,
  boxShadow: "inset 0 1px 2px rgba(15,23,42,0.03)",
}

export const textareaStyle = {
  ...ui.textarea,
  minHeight: 120,
  padding: "12px 14px",
  fontWeight: 500,
  lineHeight: 1.55,
}

const sharedButtonBase = {
  minHeight: 40,
  padding: "0 14px",
  borderRadius: 14,
}

export const buttonStyle = {
  ...ui.secondaryButton,
  ...sharedButtonBase,
}

export const primaryButtonStyle = {
  ...ui.primaryButton,
  ...sharedButtonBase,
}

export const ghostButtonStyle = {
  ...ui.ghostButton,
  ...sharedButtonBase,
}

export const dangerButtonStyle = {
  ...ui.dangerButton,
  ...sharedButtonBase,
}

export const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(15,23,42,0.48)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
  zIndex: 1000,
}

export const modalCardStyle = {
  ...ui.card,
  width: "min(1100px, 100%)",
  maxHeight: "90vh",
  overflowY: "auto",
  borderRadius: 20,
  boxShadow: "0 24px 80px rgba(15,23,42,0.18)",
}